'use client';

import React from 'react';

export const RegFormField = ({
  label,
  name,
  value,
  onChange,
  error,
  required = false,
  readOnly = false,
  placeholder,
  type = 'text',
  className = '',
  ...props
}) => {
  const baseInputClasses = 'w-full p-4 border rounded-lg focus:outline-none';
  const errorClasses = error
    ? 'border-2 border-[#D32F2F] focus:border-[#D32F2F] focus:ring-[#D32F2F]'
    : 'border-gray-300 focus:border-[#006EB7]';

  return (
    <div className={`mb-6 ${className}`}>
      <label htmlFor={name} className="text-[#373945] text-base font-medium mb-2 block">
        {label}
      </label>
      <input
        type={type}
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
        className={`${baseInputClasses} ${errorClasses}`}
        {...props}
      />
      {/*{error && (
        <div className="pt-2">
          <p className="flex text-[#D0342C]">
            <img src="/img/icons/info-circle.svg" alt="Info" className="pr-2" />
            {error}
          </p>
        </div>
      )}*/}
    </div>
  );
};
